/* eslint-disable no-console */
const statusMsgs = document.querySelectorAll('.form-status-message');

const hideMessage = () => {
  for (let i = 0; i < statusMsgs.length; i++) { /* eslint-disable-line no-plusplus */
    statusMsgs[i].classList.add('hidden');
    statusMsgs[i].classList.remove('infobox-fade');
  }
};

const showMessage = () => {
  for (let i = 0; i < statusMsgs.length; i++) { /* eslint-disable-line no-plusplus */
    statusMsgs[i].classList.remove('hidden');
    statusMsgs[i].classList.add('infobox-fade');
  }
  setTimeout(() => {
    hideMessage();
  }, 4000);
};

const setMessage = (msg) => {
  for (let i = 0; i < statusMsgs.length; i++) { /* eslint-disable-line no-plusplus */
    statusMsgs[i].innerHTML = msg;
  }
};

export {
  hideMessage,
  setMessage,
  showMessage,
};
/* eslint-enable no-console */
